




























































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { GetProvinces, GetCity, GetDistrict, getObsToken } from '../../../api/common/index';
import { GetenterpriseDetail, UpdateenterpriseDetail, checkBpCaptcha } from '../../../api/enterprise/index';

@Component({
  name: 'EnterpriseSetting',
})
export default class EnterpriseSetting extends Vue {
  setFormRef = null;
  uploadServer = '';
  validText = '验证';
  setForm = {
    name: '',
    logoUrl: '',
    provinceCode: '',
    cityCode: '',
    districtCode: '',
    address: '',
    phone: '',
    captcha: '',
    channelDescription: '',
  };
  setFormRules = {};
  uploadPlayload = {};
  acceptImgType = '.png,.PNG, .jpg,.JPG, .JPEG,.jpeg';
  proviceList = [];
  cityList = [];
  disList = [];
  isShowTip = false;

  async mounted() {
    await this.getDetail();
    await this.getProvince();
  }
  async getDetail() {
    await GetenterpriseDetail().then(res => {
      console.log('查询的结果', res);
      this.isShowTip = false;
      if (res.bpSn && res.bpSn != '') {
        this.validText = '重新绑定';
        this.isShowTip = true;
      }
      Object.keys(this.setForm).forEach(key => {
        (this.setForm as any)[key] = res[key];
      });
    });
    this.proviceChange();
    this.cityChange();
  }

  async getProvince() {
    await GetProvinces().then(res => {
      this.proviceList = res;
    });
  }
  async proviceChange() {
    await GetCity({ code: this.setForm.provinceCode }).then(res => {
      this.cityList = res;
    });
  }
  async cityChange() {
    await GetDistrict({ code: this.setForm.cityCode }).then(res => {
      this.disList = res;
    });
  }

  // 校验验证码
  async validateCode() {
    await checkBpCaptcha({
      captcha: this.setForm.captcha,
    })
      .then(() => {
        this.$message.success('验证通过');
      })
      .catch(err => {
        console.log('捕获的数据', err);
        this.setForm.captcha = '';
      });
  }

  handleUploadSuccess(res: any, file: any) {
    this.setForm.logoUrl = file.raw.originalUrl;
  }

  async handleBeforeUpload(file: any) {
    try {
      let suffix = file.type.split('/')[1];
      let res = await getObsToken({ suffix });
      this.uploadServer = res.host;
      this.uploadPlayload = {
        key: res.key,
        policy: res.policy,
        signature: res.signature,
        AccessKeyId: res.accessid,
        success_action_status: '200',
      };
      file.originalUrl = res.cdn + res.key;
    } catch (e) {
      console.log(e);
    }
  }

  handleSuccess(e: any, file: any) {
    let url = file.raw.originalUrl;
    this.setForm.logoUrl = url;
  }

  async handleUpdate() {
    await UpdateenterpriseDetail(this.setForm).then(() => {
      this.$message.success('更新成功');
    });
    await this.getDetail();
  }
}
